import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { usePageTracking } from "./hooks/usePageTracking";
import { useGoogleAnalytics } from "./hooks/useGoogleAnalytics";

function AppContent() {
  usePageTracking();
  useGoogleAnalytics();
  return <AppRoutes />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppContent />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
